// Per-tick views and toasts derived from the sim snapshot, plus the sound
// bridge. Extracted from App.tsx (ROADMAP 7.14); the hook order is unchanged.

import { useSounds } from '../audio/useSounds.js';
import { useDiplomacyViews } from '../dynasty/useDiplomacyViews.js';
import { useTreatyNews } from '../dynasty/useTreatyNews.js';
import { useEspionageView } from '../espionage/useEspionageView.js';
import { useHeroCaptivityView } from '../heroes/useHeroCaptivityView.js';
import { useHeroQuestsView } from '../heroes/useHeroQuestsView.js';
import { useAttackToasts } from '../sim/useAttackToasts.js';
import { usePendingMerchantOffer } from '../sim/useMerchantOffer.js';
import { useResearchToasts } from '../sim/useResearchToasts.js';
import type { SimWorld } from '../sim/useSimWorld/index.js';

export function useSimFeeds(sim: SimWorld, localPlayerIndex: number) {
  const pendingOffer = usePendingMerchantOffer(sim.snapshot, localPlayerIndex);
  const { diplomacy, dynasty } = useDiplomacyViews(sim.snapshot);
  const espionage = useEspionageView(sim.snapshot, localPlayerIndex);
  const heroCaptivity = useHeroCaptivityView(sim.snapshot);
  const heroQuests = useHeroQuestsView(sim.snapshot, localPlayerIndex);
  const treatyDesk = useTreatyNews(
    diplomacy,
    dynasty,
    Number(sim.tick),
    localPlayerIndex,
    sim.treaty,
  );
  const { toasts: attackToasts, dismiss: dismissToast } = useAttackToasts(
    sim.snapshot,
    localPlayerIndex,
  );
  const { toasts: researchToasts, dismiss: dismissResearchToast } = useResearchToasts(
    sim.snapshot,
    localPlayerIndex,
  );
  useSounds(sim.events ?? []);

  return {
    pendingOffer,
    diplomacy,
    dynasty,
    espionage,
    heroCaptivity,
    heroQuests,
    treatyDesk,
    attackToasts,
    dismissToast,
    researchToasts,
    dismissResearchToast,
  };
}
